





































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateShop, UpdateShop, QueryShopById, QueryBankCodeList,QueryBankBranchList, QueryMccList,SubmitShopAuditStatus,QueryShopRegistMerchantListById } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import pcaData from '@/assets/pca.json'
import Rules from '@/utils/rules'
import constant from '@/utils/constant'
import { MessageBox } from 'element-ui'
import MerchantOpenCard from './components/MerchantOpenCard.vue'

@Component({
  components: {
    VImageUpload,
    MerchantOpenCard
  },
})
export default class EditShopDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {
      province: undefined,
      city: undefined,
      district: undefined,
      bankCard: { bankType: 1,province:undefined,city:undefined,branchCode:undefined },
      businessLicenseValidityType: "0",
      certValidityType: "0",
      legalLicenceValidityType: "0",
      sjtype: 0,
      sjtypeList: [],
    }
    this.openMerchantList = []
    this.show = false
  }

  private data: any = {
    province: undefined,
    city: undefined,
    district: undefined,
    bankCard: { bankType: 1,province:undefined,city:undefined,branchCode:undefined },
    businessLicenseValidityType: "0",
    certValidityType: "0",
    legalLicenceValidityType: "0",
    sjtype: 0,
    sjtypeList: [], // 商家类型多选列表
  }
  private show = false
  private buttonLoading = false
  private isEdit = false
  private pca = pcaData
  // 银行列表
  private bankList: any[] = []
  // 银行支行
  private bankBranchList: any[] = []
  // 行业
  private mccList: any[] = []
  private ValidityType = constant.ValidityType

  // 获取省数据
  private get provinceList() {
    return this.pca
  }
  // 获取市数据
  private get cityList() {
    if (!this.data.province) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.province)
    if (t.length <= 0) {
      return []
    }
    return t[0].children
  }
  private get bankCityList() {
    if (!this.data.bankCard.province) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.bankCard.province)
    if (t.length <= 0) {
      return []
    }
    return t[0].children
  }
  // 获取区数据
  private get districtList() {
    if (!this.data.province || !this.data.city) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.province)
    if (t.length <= 0) {
      return []
    }
    const t2 = t[0].children.filter((e: any) => e.name == this.data.city)
    if (t2.length == 0) {
      return []
    }
    return t2[0].children
  }

  private provinceChange() {
    console.log("dsadsa")
    this.data.city = undefined;
    this.data.district = undefined;
  }

  // 处理商家类型多选框变化
  private handleSjtypeChange(values: number[]) {
    // 使用位运算合并选中的值
    // 1 = 精选商家, 2 = 新商家
    // 如果同时选中，则 sjtype = 1 | 2 = 3
    let sjtype = 0
    if (values.includes(1)) {
      sjtype |= 1 // 添加精选商家标识
    }
    if (values.includes(2)) {
      sjtype |= 2 // 添加新商家标识
    }
    this.data.sjtype = sjtype
    console.log('商家类型变化:', values, '-> sjtype:', sjtype)
  }

  private mccCodeChange(){
    const res = this.mccList.filter(e => e.code == this.data.mccCode)
    if (res.length > 0) {
      this.data.mccName = res[0].oneClassifyName+"/"+res[0].twoClassifyName+"/"+res[0].mccName
    } else {
      this.data.mccName = ""
    }
  }

  private bankChange() {
    const res = this.bankList.filter(e => e.bankCode == this.data.bankCard.bankCode)
    if (res.length > 0) {
      this.data.bankCard.bankName = res[0].bankName
      this.data.bankCard.branchCode = undefined
      this.loadBankBranch()
    } else {
      this.data.bankCard.bankName = ""
    }
  }

  private changeBankProvice(){
    this.data.bankCard.city = undefined
    this.data.bankCard.branchCode = ''
    this.loadBankBranch()
  }

  private selectBankBranch = ''
  private bankBranchLoading = false
  private loadBankBranch(text = undefined){
    this.bankBranchLoading = true
    // 加载支行
    if(this.data.bankCard && this.data.bankCard.bankCode && this.data.bankCard.province){
      const res = this.bankList.filter(e => e.bankCode == this.data.bankCard.bankCode)
      const param: any = {bankCode:res[0].huifuBankCode}
      if(this.data.bankCard.province){
        param.branchName = this.data.bankCard.province
      }
      if(text){
        param.branchName = text
      }
      QueryBankBranchList(param).then(res=>{
        this.bankBranchList = res
        this.bankBranchLoading = false
      })
    }
  }

  private openMerchantList:any[] =[] // 开户信息
  // 加载商户
  private loadMerchant(){
    QueryShopRegistMerchantListById({id:this.data.id}).then((res:any)=>{
      const d = res
      if(d.filter((e:any)=>e.payChannel == 'huifu').length <= 0){
        d.push({
          payChannel: "huifu",
          payChannelName: "汇付支付",
          applicationStatus: "WAIT"
        })
      }
      if(d.filter((e:any)=>e.payChannel == 'llpay').length <= 0){
         d.push({
          payChannel: "llpay",
          payChannelName: "连连支付",
          applicationStatus: "WAIT"
        })
      }
      this.openMerchantList = d
    })
  }

  public created() {
    // 加载银行卡列表
    QueryBankCodeList({}).then(res => {
      this.bankList = res.list
    })
    QueryMccList({}).then(res=>{
      this.mccList = res.list
    })
  }

  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.isEdit = isEdit
    this.loadShopById(data.id)

  }

  private async loadShopById(shopId: any) {
    const data = await QueryShopById({ id: shopId })
    if(!data.bankCard){
      data.bankCard =  { bankType: 1,province:undefined,city:undefined,branchCode: undefined }
    }
    if(!data.bankCard.city){
      data.bankCard.city = undefined
    }
    if(!data.bankCard.branchCode){
      data.bankCard.branchCode = undefined
    }
    this.data = { ...this.data, ...data }
    // 去加载支行
    this.loadBankBranch()
    // 加载开户信息
    this.loadMerchant()

    // 加载绑定商品

    if (this.data.logo) {
      this.data.logoList = this.data.logo.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.logo = undefined
      this.data.logoList = []
    }
    if (this.data.businessLicense) {
      this.data.businessLicenseList = this.data.businessLicense.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.businessLicense = undefined
      this.data.businessLicenseList = []
    }
    if (this.data.openAccountLicenceUrl) {
      this.data.openAccountLicenceUrlList = this.data.openAccountLicenceUrl.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.openAccountLicenceUrl = undefined
      this.data.openAccountLicenceUrlList = []
    }
    if (this.data.legalLicenceFrontUrl) {
      this.data.legalLicenceFrontUrlList = this.data.legalLicenceFrontUrl.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.legalLicenceFrontUrl = undefined
      this.data.legalLicenceFrontUrlList = []
    }
    if (this.data.legalLicenceBackUrl) {
      this.data.legalLicenceBackUrlList = this.data.legalLicenceBackUrl.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.legalLicenceBackUrl = undefined
      this.data.legalLicenceBackUrlList = []
    }

    if (this.data.storeHeaderPic) {
      this.data.storeHeaderPicList = this.data.storeHeaderPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.storeHeaderPic = undefined
      this.data.storeHeaderPicList = []
    }

    if (this.data.storeIndoorPic) {
      this.data.storeIndoorPicList = this.data.storeIndoorPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.storeIndoorPic = undefined
      this.data.storeIndoorPicList = []
    }

    if (this.data.storeCashierDeskPic) {
      this.data.storeCashierDeskPicList = this.data.storeCashierDeskPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.storeCashierDeskPic = undefined
      this.data.storeCashierDeskPicList = []
    }

    if (this.data.bankCard.settleCardFrontPic) {
      this.data.bankCard.settleCardFrontPicList = this.data.bankCard.settleCardFrontPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.bankCard.settleCardFrontPic = undefined
      this.data.bankCard.settleCardFrontPicList = []
    }

    if (this.data.bankCard.settleCertBackPic) {
      this.data.bankCard.settleCertBackPicList = this.data.bankCard.settleCertBackPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.bankCard.settleCertBackPic = undefined
      this.data.bankCard.settleCertBackPicList = []
    }

    if (this.data.bankCard.settleCertFrontPic) {
      this.data.bankCard.settleCertFrontPicList = this.data.bankCard.settleCertFrontPic.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.bankCard.settleCertFrontPic = undefined
      this.data.bankCard.settleCertFrontPicList = []
    }

    // 将 sjtype 转换为多选列表
    // sjtype 使用位运算存储：1=精选，2=新商家，3=精选+新商家
    this.data.sjtypeList = []
    // 确保 sjtype 有默认值
    if (this.data.sjtype === undefined || this.data.sjtype === null) {
      this.data.sjtype = 0
    }
    // 转换为多选列表
    if (this.data.sjtype & 1) { // 包含精选商家
      this.data.sjtypeList.push(1)
    }
    if (this.data.sjtype & 2) { // 包含新商家
      this.data.sjtypeList.push(2)
    }

    // 确保 score 有默认值
    if (this.data.score === undefined || this.data.score === null) {
      this.data.score = 5.0
    }

  }

  private requiredRule = { required: true,message: '不能为空', trigger: ['change', 'blur'], }
  private requiredArrayRule = { required: true, type: 'array', message: '不能为空', trigger: ['change', 'blur'], }
  private rules = {
    // 店铺信息
    name: [this.requiredRule],
    kfPhone: [this.requiredRule],
    mccCode: [this.requiredRule],
    address: [this.requiredRule],
    shopDesc: [this.requiredRule],
    logoList: [this.requiredRule],
    storeHeaderPicList: [this.requiredRule],
    storeIndoorPicList: [this.requiredRule],
    storeCashierDeskPicList: [this.requiredRule],

    // 企业信息
    shopType: [this.requiredRule],
    companyName: [this.requiredRule],
    creditCode: [this.requiredRule],
    businessLicenseList: [this.requiredRule],
    businessLicenseValidityType: [this.requiredRule],
    businessLicenseBeginDate: [this.requiredRule],
    businessLicenseEndDate: [this.requiredRule],
    businessLicenseFoundDate: [this.requiredRule],
    regCapital: [this.requiredRule],
    openAccountLicenceUrlList: [this.requiredRule],
    openLicenceNo: [this.requiredRule],

    // 银行卡信息
    'bankCard.bankType': [this.requiredRule],
    'bankCard.bankCode': [this.requiredRule],
    'bankCard.branchCode': [this.requiredRule],
    'bankCard.accountName': [this.requiredRule],
    'bankCard.accountNo': [this.requiredRule],
    'bankCard.settleCardFrontPicList': [this.requiredRule],

    // 对私银行卡额外字段
    'bankCard.bindMobilePhone': [this.requiredRule],
    'bankCard.certNo': [this.requiredRule],
    'bankCard.certValidityType': [this.requiredRule],
    'bankCard.certBeginDate': [this.requiredRule],
    'bankCard.certEndDate': [this.requiredRule],
    'bankCard.settleCertBackPicList': [this.requiredRule],
    'bankCard.settleCertFrontPicList': [this.requiredRule],

    // 法人信息
    legalName: [this.requiredRule],
    legalPhone: [this.requiredRule],
    legalLicenceNo: [this.requiredRule],
    legalLicenceFrontUrlList: [this.requiredRule],
    legalLicenceBackUrlList: [this.requiredRule],
    legalLicenceValidityType: [this.requiredRule],
    legalLicenceBeginDate: [this.requiredRule],
    legalLicenceEndDate: [this.requiredRule],
    legalLicenceAddress: [this.requiredRule],

    // 管理员信息
    contactsName: [this.requiredRule],
    contactsLicenceNo: [this.requiredRule],
    contactsEmail: [this.requiredRule, Rules.isEmail],
    contactsPhone: [this.requiredRule, Rules.isMobile]
  }

  // 提交审核
  private submitAudit(){
    MessageBox.confirm('是否确定要提交审核？', '提示', {
      type: 'warning',
    }).then(async () => {
      await this.save(true)
    })
  }

  public async save(isSubmitAudit = false) {
    this.buttonLoading = true
    try {

      // 参数
      await this.loadParam()

      const form = this.$refs.form as ElForm
      form.validate(async (valid: boolean) => {
        if (valid) {

          console.log(this.data)

          let result: any = await UpdateShop(this.data)
          // if (this.isEdit) {
          //   result = await UpdateShop(this.data)
          // } else {
          //   result = await CreateShop(this.data)
          // }
          console.log(result)
          if (result) {
            if(isSubmitAudit){
              await SubmitShopAuditStatus({ id: this.data.id })
            }

            this.close()
          }

        } else {
          this.$message.error("表单存在错误，不能保存")
          return false
        }

      })
    } finally {
      this.buttonLoading = false
    }
  }

  // 暂存
  public async save2() {
    this.buttonLoading = true
    try {

      // 参数
      await this.loadParam()
      console.log(this.data)

      let result = await UpdateShop(this.data)
      // if (this.isEdit) {
      //   result = await UpdateShop(this.data)
      // } else {
      //   result = await CreateShop(this.data)
      // }
      console.log(result)
      if (result) {
        this.close()
      }

    } finally {
      this.buttonLoading = false
    }
  }

  private async loadParam(){

      this.data.logo = this.data.logoList?.map((e: any) => e.url).join(',')
      this.data.businessLicense = this.data.businessLicenseList?.map((e: any) => e.url).join(',')
      this.data.openAccountLicenceUrl = this.data.openAccountLicenceUrlList?.map((e: any) => e.url).join(',')
      this.data.legalLicenceFrontUrl = this.data.legalLicenceFrontUrlList?.map((e: any) => e.url).join(',')
      this.data.legalLicenceBackUrl = this.data.legalLicenceBackUrlList?.map((e: any) => e.url).join(',')
      this.data.storeHeaderPic = this.data.storeHeaderPicList?.map((e: any) => e.url).join(',');
      this.data.storeIndoorPic = this.data.storeIndoorPicList?.map((e: any) => e.url).join(',');
      this.data.storeCashierDeskPic = this.data.storeCashierDeskPicList?.map((e: any) => e.url).join(',');
      this.data.bankCard.settleCardFrontPic = this.data.bankCard.settleCardFrontPicList?.map((e: any) => e.url).join(',');
      this.data.bankCard.settleCertBackPic = this.data.bankCard.settleCertBackPicList?.map((e: any) => e.url).join(',');
      this.data.bankCard.settleCertFrontPic = this.data.bankCard.settleCertFrontPicList?.map((e: any) => e.url).join(',');
       // 获取经纬度
      const address = this.data.province+this.data.city+this.data.district+this.data.address
      const location = await TxLocal.getLal(address)
      this.data.longitude = location.location.lng
      this.data.latitude = location.location.lat
  }

}
